export const isNumber = (value: unknown): value is number => typeof value === 'number' && !Number.isNaN(value);

export const toNumber = (value: string): number | null => {
  if (value === '') return null;

  const number = Number(value);
  return isNumber(number) ? number : null;
};

export const range = ({ min, max }: { min: number; max: number }): number[] =>
  new Array(max - min + 1).fill(null).map((_, index) => index + min);

export const random = ({ min = 0, max }: { min?: number; max: number }): number =>
  min + Math.floor(Math.random() * (max - min));
